export const CHART_REDUCER_STATE_ID = 'chart';
export const TYPE_CHART_REDUCER_CHART_ID = 'haiByType';
export const ORGANIZATION_CHART_REDUCER_CHART_ID = 'haiByOrganization';
export const TREND_CHART_REDUCER_CHART_ID = 'haiByTrend';

export const CRP_IN_TIME_CHART_REDUCER_CHART_ID = 'crpInTime';
export const PCT_IN_TIME_CHART_REDUCER_CHART_ID = 'pctInTime';
export const WBC_IN_TIME_CHART_REDUCER_CHART_ID = 'wbcInTime';
